import Header from '../components/Header';
import Footer from '../components/Footer';
import ValueCard from '../components/ValueCard';

const OurValues = () => {
  const values = [
    {
      title: "Deliver Great Outcomes",
      description: "Enabling young people to reach their potential and achieve meaningful goals."
    },
    {
      title: "Never Give Up",
      description: "Adapting, problem-solving, and embracing innovation to overcome challenges."
    },
    {
      title: "In It Together",
      description: "Collaborating as a supportive, united team and with families and communities."
    },
    {
      title: "Up for the Challenge",
      description: "Maintaining professionalism, confidence, and excellence in all situations."
    },
    {
      title: "Build Trust",
      description: "Acting with honesty, reliability, transparency, and accountability."
    },
    {
      title: "Develop Great Relationships",
      description: "Fostering compassionate, positive, and lasting connections."
    }
  ];

  const focusAreas = [
    {
      title: "Individualised Care",
      description:
        "Every young person receives tailored therapeutic support that meets their emotional, social, and educational needs."
    },
    {
      title: "Education and Life Skills",
      description:
        "We help children and young people develop the knowledge, skills, and confidence they need to thrive now and in the future."
    },
    {
      title: "Wellbeing and Resilience",
      description:
        "Promoting mental health, physical wellbeing, and emotional resilience is at the heart of everything we do."
    },
    {
      title: "Strong Relationships",
      description:
        "We work closely with families, communities, and professionals to build positive, lasting connections that support each young person's growth."
    },
    {
      title: "Quality and Safety",
      description:
        "We are committed to the highest standards of care, safeguarding, and continuous improvement to ensure a safe and nurturing environment."
    }
  ];

  return (
    <div className="OurValues">
      <Header />
      <div className="mt-32 sm:mt-36 lg:mt-32">
        {/* Hero Section */}
        <div
        className="relative bg-cover bg-center min-h-[50vh] sm:min-h-[55vh] lg:min-h-[60vh]"
        style={{
          backgroundImage: "url('/assets/images/tc-heart-hands.jpeg')",
        }}
      >
        <div className="absolute inset-0 flex items-end justify-center pb-0">
          <div className="w-full bg-white bg-opacity-90 py-6 sm:py-8 px-4 sm:px-6 lg:px-8">
            <div className="max-w-6xl mx-auto text-center">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-light mb-0" style={{ color: '#000' }}>
                Our Values
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Values Grid */}
      <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8" style={{ backgroundColor: '#f2f4f7' }}>
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {values.map((value, index) => (
              <ValueCard
                key={index}
                title={value.title}
                description={value.description}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Focus Areas */}
      <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="mb-8 text-center">
            <h2 className="text-2xl sm:text-3xl font-light text-[#2b3d57]">Our Focus Areas</h2>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
            {focusAreas.map((area, index) => (
              <div
                key={index}
                className="bg-[#f5f0eb] rounded-2xl p-6 shadow-[0_12px_30px_rgba(15,23,42,0.08)] border border-[#e2e8f0]"
              >
                <h3 className="text-lg font-semibold text-[#2f4c74] mb-3">{area.title}</h3>
                <p className="text-sm sm:text-base text-[#3f4a59] leading-relaxed">{area.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-10 sm:py-12 px-4 sm:px-6 lg:px-8 bg-white">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col md:flex-row items-center justify-center md:justify-between gap-6 sm:gap-8">
            <h2 className="text-xl sm:text-2xl md:text-3xl font-normal text-center md:text-left" style={{ color: '#000' }}>
              Ready to start your journey with us?
            </h2>
            <a
              href="/join-our-team"
              className="px-8 sm:px-12 lg:px-16 py-3 sm:py-4 text-white text-base sm:text-lg font-normal hover:opacity-90 transition-opacity"
              style={{ backgroundColor: '#2f4c74', minWidth: '250px', textAlign: 'center', display: 'block' }}
            >
              Apply Today
            </a>
          </div>
        </div>
      </section>

        <Footer />
      </div>
    </div>
  );
};

export default OurValues;



